export default __webpack_public_path__ + "static/media/meta.b8e71dbf.png";